import { NewsletterStaticVariant } from '@/types/views/sections';

const PREFIX_BY_VARIANT: Record<NewsletterStaticVariant, string> = {
  newsletter: 'newsletter',
  event: 'event-registration',
};

const getVariantVariableKey = (
  variant: NewsletterStaticVariant,
  suffix: string,
): string => `${PREFIX_BY_VARIANT[variant]}-${suffix}`;

export default getVariantVariableKey;
